import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { InlineFieldLayout } from '../index.js';
export const GroupLayoutWrapper = styled.div `
  display: flex;
  flex-direction: column;

  ${InlineFieldLayout}:not(:last-child) {
    margin-bottom: ${(props) => props.theme.spacing.sm};
  }
`;
export const GroupLayout = ({ children, ...rest }) => (_jsx(GroupLayoutWrapper, { ...rest, children: children }));
